import { render, staticRenderFns } from "./CGVProposals.vue?vue&type=template&id=72635a3d&scoped=true"
import script from "./CGVProposals.vue?vue&type=script&lang=js"
export * from "./CGVProposals.vue?vue&type=script&lang=js"
import style0 from "./CGVProposals.vue?vue&type=style&index=0&id=72635a3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72635a3d",
  null
  
)

export default component.exports